import gql from 'graphql-tag';

export const createNotifyOptInMutation = gql`
	mutation createNotifyOptIn($cappedProgramData: CreateNotifyOptInInput!) {
		createNotifyOptIn(cappedProgramData: $cappedProgramData) {
			academicPartnerUuid
			createdAt
			programId
		}
	}
`;

export const getNotifyOptIn = gql`
	query getNotifyMeWhenOptIn($programId: ID!) {
		getNotifyMeWhenOptIn(programId: $programId) {
			programId
		}
	}
`;
